

import { Component, Injector, OnInit } from '@angular/core';
import { TriggerHistoryConstants } from 'tnx-admin-service/scheduletriggerhistory/constants';
import { ScheduleTriggerService } from 'tnx-admin-service/scheduletrigger/services';
import { ScheduleTriggerHistoryService } from 'tnx-admin-service/scheduletriggerhistory/services';
import {
    ComponentContextService, DataFormBase, DateTimeControlSchema, DropdownControlSchema, EventData, FormSchemaBase, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'scheduletriggerhistory-form',
    templateUrl: './scheduletriggerhistory-form.component.html',
    styleUrls: ['./scheduletriggerhistory-form.component.scss'],
    providers: [ComponentContextService],
})
export class ScheduleTriggerHistoryFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _scheduleTriggerService: ScheduleTriggerService,
        private _scheduleTriggerHistoryService: ScheduleTriggerHistoryService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._scheduleTriggerHistoryService;
        this.setting.schema = <FormSchemaBase[]>[
            new DropdownControlSchema({
                label: 'Lịch trình',
                fullLabel: 'Lịch trình',
                field: 'idTrigger',
                baseService: this._scheduleTriggerService,
                displayField: 'name',
                valueField: 'id',
                mdWidth: 12,
                disabled: true,
            }),
            new TextControlSchema({
                label: 'Trạng thái lịch trình',
                fullLabel: 'Trạng thái lịch trình này đang như nào.  Failed, Stop, Running, Finished',
                field: 'callbackStatus',
                dataFormat: 'number',
                disabled: true,
            }),
            new DropdownControlSchema({
                label: 'Trạng thái callback',
                fullLabel: 'Trạng thái callback',
                field: 'callbackStatus',
                displayField: 'label',
                valueField: 'value',
                mdWidth: 6,
                dataSource: TriggerHistoryConstants.TriggerHistoryCallbackStatusDataSource,
                disabled: true,
            }),
            new DropdownControlSchema({
                label: 'Trạng thái timeout',
                fullLabel: 'Trạng thái timeout',
                field: 'timeoutStatus',
                displayField: 'label',
                valueField: 'value',
                mdWidth: 6,
                dataSource: TriggerHistoryConstants.TriggerHistoryTimeoutStatusDataSource,
                disabled: true,
            }),
            new TextControlSchema({
                label: 'Thời gian timeout (giây)',
                fullLabel: 'Thời gian timeout (giây)',
                field: 'currentTimeout',
                dataFormat: 'number',
                disabled: true,
            }),
            new TextControlSchema({
                label: 'Dữ liệu gửi kèm (json)',
                fullLabel: 'Dữ liệu gửi kèm (json)',
                field: 'data',
                disabled: true,
            }),
            new DateTimeControlSchema({
                label: 'Thời gian bắt đầu chạy',
                fullLabel: 'Thời gian bắt đầu chạy',
                field: 'startTriggerAt',
                showTime: true,
                disabled: true,
            }),
            new DateTimeControlSchema({
                label: 'Thời gian kết thúc chạy',
                fullLabel: 'Thời gian kết thúc chạy',
                field: 'endTriggerAt',
                showTime: true,
                disabled: true,
            }),
            new TextControlSchema({
                label: 'Lỗi',
                fullLabel: 'Lỗi',
                field: 'errorMessage',
                disabled: true,
            }),
            new DateTimeControlSchema({
                label: 'Thời gian tạo',
                fullLabel: 'Thời gian tạo',
                field: 'created',
                showTime: true,
                disabled: true,
            }),

        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail

    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    onBeforeSave() {
        // trước khi lưu
    }
}
